import * as React from 'react';
import { BaSeI18nContext } from '../contexts/i18n';
import { BaSeErrorPage } from './error';

export const BaSeForbiddenPage: React.FC = () => {
  const { getMessage } = React.useContext(BaSeI18nContext);
  return (
    <BaSeErrorPage
      title={getMessage('forbiddenPage.title')}
      error={getMessage('forbiddenPage.errorMessage')}
    />
  );
};
